<div class="login-container">
  <!-- Left Side - Visual Panel -->
  <div class="w-50 d-none d-lg-block">
    <app-left-ui-template
      welcomeText="Reset Your Password"
      welcomeSubtitle="We'll guide you through a quick reset so you can continue discovering
        meaningful connections">
    </app-left-ui-template>
  </div>
  <div class="reset-container">
    <div class="">
      <div class="logo-container">
        <div class="logo">
          <i class="pi pi-lock"></i>
        </div>
      </div>

      <h1 class="title">Reset Password</h1>
      <p class="subtitle">Create a strong password to secure your account</p>

      <div class="form-container">
        <!-- New Password Field -->
        <div class="form-group">
          <label class="form-label">New Password</label>
          <div class="password-wrapper">
            <input
              [type]="showNewPassword() ? 'text' : 'password'"
              pInputText
              class="password-input"
              placeholder="Enter new password"
              [disabled]="isProcessing()"
              [ngModel]="newPassword()"
              (ngModelChange)="newPassword.set($event)"
              autocomplete="new-password"
              data-form-type="other" />
            <button
              type="button"
              class="toggle-password"
              (click)="toggleNewPasswordVisibility()">
              <i
                [class]="
                  showNewPassword() ? 'pi pi-eye' : 'pi pi-eye-slash'
                "></i>
            </button>
          </div>

          <!-- Password Strength Indicator -->
          @if (newPassword()) {
            <div class="strength-container">
              <div class="strength-bar-wrapper">
                <div
                  class="strength-bar"
                  [ngClass]="passwordStrength().class"
                  [style.width.%]="passwordStrength().value"></div>
              </div>
              <span class="strength-label" [ngClass]="passwordStrength().class">
                {{ passwordStrength().label }}
              </span>
            </div>
          }
        </div>

        <!-- Confirm Password Field -->
        <div class="form-group">
          <label class="form-label">Confirm Password</label>
          <div class="password-wrapper">
            <input
              [type]="showConfirmPassword() ? 'text' : 'password'"
              pInputText
              class="password-input"
              [disabled]="isProcessing()"
              placeholder="Re-enter new password"
              [(ngModel)]="confirmPassword"
              (ngModelChange)="confirmPassword.set($event)" />
            <button
              type="button"
              class="toggle-password"
              (click)="toggleConfirmPasswordVisibility()">
              <i
                [class]="
                  showConfirmPassword() ? 'pi pi-eye' : 'pi pi-eye-slash'
                "></i>
            </button>
          </div>

          <!-- Password Match Indicator -->
          @if (confirmPassword() && !passwordsMatch()) {
            <div class="error-message">
              <i class="pi pi-times-circle"></i>
              Passwords do not match
            </div>
          }
          @if (confirmPassword() && passwordsMatch()) {
            <div class="success-message">
              <i class="pi pi-check-circle"></i>
              Passwords match
            </div>
          }
        </div>

        <!-- Password Requirements -->
        <div class="requirements-container">
          <p class="requirements-title">Password must contain:</p>
          <div class="requirements-list">
            <div class="requirement-item" [ngClass]="{ valid: hasMinLength() }">
              <i
                [class]="
                  hasMinLength() ? 'pi pi-check-circle' : 'pi pi-circle'
                "></i>
              <span>At least 8 characters</span>
            </div>
            <div class="requirement-item" [ngClass]="{ valid: hasUpperCase() }">
              <i
                [class]="
                  hasUpperCase() ? 'pi pi-check-circle' : 'pi pi-circle'
                "></i>
              <span>One uppercase letter</span>
            </div>
            <div class="requirement-item" [ngClass]="{ valid: hasLowerCase() }">
              <i
                [class]="
                  hasLowerCase() ? 'pi pi-check-circle' : 'pi pi-circle'
                "></i>
              <span>One lowercase letter</span>
            </div>
            <div class="requirement-item" [ngClass]="{ valid: hasNumber() }">
              <i
                [class]="
                  hasNumber() ? 'pi pi-check-circle' : 'pi pi-circle'
                "></i>
              <span>One number</span>
            </div>
            <div
              class="requirement-item"
              [ngClass]="{ valid: hasSpecialChar() }">
              <i
                [class]="
                  hasSpecialChar() ? 'pi pi-check-circle' : 'pi pi-circle'
                "></i>
              <span>One special character (&#64;, #, $, etc.)</span>
            </div>
          </div>
        </div>

        <!-- Reset Button -->
        <button
          pButton
          [label]="isProcessing() ? 'Processing...' : 'Reset Password'"
          class="reset-button"
          [disabled]="!isFormValid()"
          (click)="resetPassword()"></button>

        <!-- Back to Login Link -->
        <div class="footer-links">
          <button
            class="back-link"
            [disabled]="isProcessing()"
            (click)="backToLogin()">
            <i class="pi pi-arrow-left"></i>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
